import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../media/felsv/white_right-arrow_icon.svg'
import InputIcon from '../../../components/Inputs/InputIcon'
import DarkArrowLeft from '../../../media/felsv/dark_left-arrow_icon.svg'

import DarkUser from '../../../media/felsv/DarkUser.svg'
import SecondaryUser from '../../../media/felsv/SecondaryUser.svg'
import DarkPass from '../../../media/felsv/dark_lock-key-alt_icon.svg'
import SecondaryPass from '../../../media/felsv/secondary_lock-key-alt_icon.svg'
import {FormCreacionUsuario} from '../../../interfaces/creacionUsuario.interface'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {bindActionCreators} from 'redux'
import {
  actionCreacionUsuario,
  actionValidatorsCreacionUsuario,
  actionsPeticiones,
} from '../../../actions/action-creators'
import {creacionUsuarioHandleChange} from '../../../actions/creacion-usuario/creacionUsuario.actions'
import {creacionUsuarioFormAddError} from '../../../actions/creacion-usuario/validacionesCreacionUsuario.actions'
import {Tooltip} from '@mui/material'
import {REGEX_PASSWORD} from '../../../constants/Regex'
import {DICCIONARIO} from '../../../constants/Diccionario'
import Help from '../../../components/DesignExterno/Help'

const UsuarioCC = (props: any) => {
  const usuario: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formUser)
  const errors: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formError)
  const [disable, setDisable] = useState(true)
  const dispatch = useDispatch()

  const {creacionUsuarioFormHandleChange} = bindActionCreators(actionCreacionUsuario, dispatch)
  const peticiones = bindActionCreators(actionsPeticiones, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)

  useEffect(() => {
    getUsername()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      usuario.username &&
      usuario.passwd &&
      usuario.passwd2 &&
      !errors.username &&
      !errors.passwd &&
      !errors.passwd2
    )
      setDisable(false)
    else setDisable(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario, errors])

  const getUsername = async () => {
    const username2 = await peticiones.obtenerUsernameAleatorio(
      usuario.first_name,
      usuario.last_name
    )
    dispatch(creacionUsuarioHandleChange({username2}))
  }

  const submit = async (e: any) => {
    e.preventDefault()
   
    if (await validaciones.validacionesCreacionUsuarioFormUsuarioSiguiente()) return

    const bool: any = await peticiones.validarUsernameConDoc(usuario.username, usuario.codigo_empresa, usuario.id_number, usuario.tipoDocumento)
    if (bool !== 'true') {
      dispatch(creacionUsuarioFormAddError({username: bool}))
      return
    }
    props.next()
  }

  const sugerencia = () => {
    dispatch(creacionUsuarioHandleChange({username: usuario.username2}))
    dispatch(creacionUsuarioFormAddError({username: ''}))
  }

  
  const handleInput = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    creacionUsuarioFormHandleChange(event)
    validaciones.validacionesCreacionUsuarioOnBlurUsuario(event)
  }


  return (
    <form
      name='wf-form-'
      data-name=''
      id='email-form'
      className='form-content'
      data-wf-page-id='64af1c9680a05070de3c97df'
      data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
      onSubmit={submit}
    >
      <div>
        <label htmlFor='username' className='field-label m' style={{display: 'flex'}}>
          {DICCIONARIO.USERNAME}
          <span style={{color: 'red'}}>*</span>
          <Help simpleMessage={null} modalTitle='' helpImage={null} id_message='username'/>
        </label>
        <InputIcon
          secondaryIcon={SecondaryUser}
          darkIcon={DarkUser}
          type='text'
          className='m text-field-icon user w-input'
          autoFocus={errors.username ? false : true}
          maxLength={15}
          minLength={2}
          name='username'
          data-name='username'
          placeholder={DICCIONARIO.USERNAME}
          id='username'
          value={usuario.username}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurUsuario}
        />
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', justifyContent: 'flex-end'}}>
          <p className='alert s' style={{maxWidth: '250px'}}>{errors.username}</p>
          <div style={{width: 'auto', marginLeft: 'auto'}}>
            <Tooltip title={usuario.username2} placement='top' arrow>
              <button
                className='s'
                type='button'
                style={{
                  color: '#13AD90',
                  textDecorationLine: 'underline',
                  backgroundColor: '#f3f3f3',
                }}
                onClick={sugerencia}
              >
                Mostrar sugerencia
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
      <div>
        <label htmlFor='passwd' className='field-label m'>
          {DICCIONARIO.PASSWORD}
          <span style={{color: 'red'}}>*</span>
        </label>
        {(!REGEX_PASSWORD.test(usuario.passwd) || !REGEX_PASSWORD.test(usuario.passwd2)) && (
          <div style={{maxWidth: 380, fontSize: 11}} className='s alert-info-text'>
            La contraseña debe tener mínimo 5 caracteres, al menos un dígito, una minúscula, una
            mayúscula y un carácter no alfanumérico.
          </div>
        )}
        <InputIcon
          secondaryIcon={SecondaryPass}
          darkIcon={DarkPass}
          type='password'
          className='m text-field-icon pass w-input'
          maxLength={50}
          name='passwd'
          data-name='passwd'
          placeholder={DICCIONARIO.PASSWORD}
          id='passwd'
          value={usuario.passwd}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurUsuario}
        />
        {errors.passwd && <p className='alert s'>{errors.passwd}</p>}
      </div>
      <div>
        <label htmlFor='passwd2' className='field-label m'>
          {DICCIONARIO.CONFIRM_PASSWORD}
          <span style={{color: 'red'}}>*</span>
        </label>
        <InputIcon
          secondaryIcon={SecondaryPass}
          darkIcon={DarkPass}
          type='password'
          className='m text-field-icon pass w-input'
          maxLength={50}
          name='passwd2'
          data-name='passwd2'
          placeholder={DICCIONARIO.CONFIRM_PASSWORD}
          id='passwd2'
          value={usuario.passwd2}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurUsuario}
        />
        {errors.passwd2 && <p className='alert s'>{errors.passwd2}</p>}
        {!errors.passwd2 &&
          usuario.passwd &&
          usuario.passwd2 &&
          usuario.passwd !== usuario.passwd2 && (
            <p className='alert s'>Las contraseñas no coinciden</p>
          )}
      </div>
      <div className='w-layout-hflex button-actions' style={{marginBottom: '5%'}}>
        <button type='button' className='m button transparent w-inline-block' onClick={props.prev}>
          <img src={DarkArrowLeft} loading='lazy' alt='Regresar' />
          Regresar
        </button>
        <button
          type='submit'
          className='m button w-inline-block'
          disabled={disable || usuario.passwd !== usuario.passwd2}
        >
          Siguiente
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default UsuarioCC
